import { Empty } from 'antd'
import React from 'react'

//styles
import "./EmptyList.css"

interface Props{
    total: number
    loading?:boolean
    children?: React.ReactNode
}

const EmptyList = ({total, children, loading}:Props) => {
  return (
    <>
    {
        (total==0 && !loading) ? 
        <div className='EmptyList-component'>
            <Empty 
            description={"No hay productos disponibles para estos parametros de busqueda."}
            image={Empty.PRESENTED_IMAGE_SIMPLE} /> 
        </div>

        : children
    }
    
    </>
  )
}

export default EmptyList